import { IPartsAppointmentForm, PartsAppointmentState, SeriesDetailsForYear, IAvail } from './parts-appointment.reducer';
import { Model, SeriesData, Trim, VehicleDetails, VehicleColor } from './../../shared/models/series-data';
import { countryCd, titleCase } from './../../shared/services/util.service';
import _ from 'lodash';
import { AppointmentStatus, AppointmentType, IAddress, IAsyncData, IAvailabilityOptions, IChecklist, IDealerInfo, ISalesAppointment, TransportationType } from '@signal/asp-data-commons';
import produce from 'immer';
import { GLOBAL_CONSTANT, convertMinsToHourMins } from '../../shared/services/util.service';
import { IAppointment, IChecklistRequest, IPartsAppointment, IPartsVehicle, IVehicle } from '@signal/asp-data-commons/lib/interfaces/appointment';
import {DateTime} from 'luxon';
import { AppointmentBookingSource, CustomerType, VehiclesOfInterest, VehicleType } from '@signal/asp-data-commons/lib/enums/enum';
// import { CustomerType } from '../../shared/enums/customer-types.enum';

export function createPartsAppointment(state: PartsAppointmentState, payload, dealerAddress, allTestDriveVehicles?: any): ISalesAppointment {
  const appointment = state.appointment;
  const appointmentComments = appointment?.appointmentComments;
  const vehicle = { ...appointment?.vehicle };
  const sanitizedVin = typeof vehicle?.vin === 'string' ? vehicle.vin.trim() : vehicle?.vin;
  if (!sanitizedVin || sanitizedVin === 'undefined') {
    delete vehicle.vin;
  } else {
    vehicle.vin = sanitizedVin;
  }
  if(vehicle["otherMake"]){
    vehicle.make = vehicle["otherMake"];
  }
  // vehicle.make = _.startCase(_.toLower(environment.brand));
  vehicle.imageUrl = vehicle?.imageUrl ? vehicle.imageUrl : state.exteriorColors.data.find(x => x.id === appointment?.vehicle?.exteriorColor)?.carImage;
  const tradeIn = appointment.tradeIn;
  const availability = { ...appointment.availability };
  const customer = appointment.customer;
  const transportationTypeCode = appointment.transportationTypeCode;
  let deliveryAddress: IAddress;

  let appt: IPartsAppointment = setPartsAppointment(payload, availability, customer, transportationTypeCode, vehicle, tradeIn, deliveryAddress, appointmentComments);
    /** booking source added for SIGNAL_CTA for create and update flow */
    if(payload['requestAppSrc'] === AppointmentBookingSource.SIGNAL_CTA) {
      appt.appointmentBookingSource = AppointmentBookingSource.SIGNAL_CTA;
    }

  if(!appointment.availability.appointmentStartDate) {
    appt.appointmentStatus =  AppointmentStatus.SAVED;
    appt.appointmentStartDate = "NA";
    appt.timeSlotId = "NA";
  }

  /* *save for later  */
  if(state?.editDetails?.appointmentStatus === AppointmentStatus.SAVED || state?.editDetails?.appointmentId?.length) {
    appt.appointmentId = state.editDetails.appointmentId;
  }
  return JSON.parse(JSON.stringify(appt).replace(/null/g, '""'));
}

export function editDataPopulatedInState(a: ISalesAppointment): IPartsAppointmentForm {
  const normalizedEditYear = a?.vehicle?.year === undefined || a?.vehicle?.year === null || a?.vehicle?.year === 'undefined'
    ? ''
    : String(a.vehicle.year);

  const state: IPartsAppointmentForm = {
    vehicle: { vin: '', ...a.vehicle, year: normalizedEditYear },
    otherVehicles: [],
    tradeIn: {
      tradeInCheckbox: !!a.tradeInVehicle && a.tradeInVehicle.length > 0,
      vehicle: a.tradeInVehicle && a.tradeInVehicle.length > 0 ? getTradeInVehicle(a.tradeInVehicle) : [ {
        year: null,
        make: null,
        model: null,
        vin: null,
        mileage: null,
        trim: null,
        isOwnVehicle: false
      }],
      title: a.title || '',
      trepresentativeInfo: a.representative || '',
      tradeInComments : a.appointmentComments ? getComment(a.appointmentComments, 'Trade-in') : '',
      dealerComments: a.appointmentComments ? getComment(a.appointmentComments, 'Comments-From-Dealer') : '',
      internalComments: a.appointmentComments? getComment(a.appointmentComments, 'Dealer-Internal-Comments'): '',
      additionalComments: a.appointmentComments? getComment(a.appointmentComments, 'Customer-Additional-Comments'): ''
    },
    transportationTypeCode: a.transportationTypeCode,
    remoteZipCode: (a.dropOffAddress && a.transportationTypeCode === 'REMOTE') ? a.dropOffAddress.zip : '',
    availability: {
      advisorId: a.advisorId,
      languageId: a.languageId,
      timeSlotId: a.timeSlotId,
      appointmentStartDate: a.appointmentStartDate,
    },
    customer: {
      firstName: a.customer.firstName,
      lastName: a.customer.lastName,
      emailAddress: a.customer.emailAddress,
      phoneNumber: a.customer.phoneNumber,
      customerType: a.customer.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
      businessName: a.customer.businessName || ''
    },
    address: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      country: countryCd
    }
  };

  state.inquiryVehicle = setInquiryVehicle(a);

  if (!a.otherVehicles) {
    state.otherVehicles.push({
      year: null,
      model: '',
      trim: ''
    });
  } else {
    state.otherVehicles = produce(a.otherVehicles, draftVehicle => {
      draftVehicle.forEach(vehicle => {
        delete vehicle.make;
      });
    });
  }

  if(a.appointmentStatus === AppointmentStatus.SAVED) {
    state.availability.advisorId = a.advisorId;
    state.availability.languageId = a.languageId;
    state.availability.appointmentStartDate = "";
    state.availability.timeSlotId = "";
  }

  if(a.appointmentType === AppointmentType.DELIVERY ) {
    if(a.appointmentStatus === AppointmentStatus.SCHEDULED) {
      state.appointmentStatus = AppointmentStatus.SCHEDULED;
    }
  }

  if (a.dropOffAddress) {
    state.address = {...state.address,...a.dropOffAddress};
  } 
  return state;
}

export function setInquiryVehicle(a: ISalesAppointment) {
  if(a.appointmentType ===  AppointmentType.VEHICLE_INQUIRY) {
    let editInquiryVehicle = {
      vehicleType: {
          new: false,
          used: false,
          both: false
      },
      vehiclesOfInterest: {
          carsMinivan: false,
          trucks: false,
          crossoversSuv: false,
          electrified: false
      }
    }
    if(a.vehicleType ===  VehicleType.BOTH) {
      editInquiryVehicle.vehicleType.new = true;
      editInquiryVehicle.vehicleType.used = true;
      editInquiryVehicle.vehicleType.both = true;
    }
    if(a.vehicleType ===  VehicleType.NEW) {
      editInquiryVehicle.vehicleType.new = true;
    }
    if(a.vehicleType ===  VehicleType.USED) {
      editInquiryVehicle.vehicleType.used = true;
    }
    a.vehiclesOfInterest?.forEach(vehicle=> {
      if(vehicle === VehiclesOfInterest.CARS_MINIVAN) {
        editInquiryVehicle.vehiclesOfInterest.carsMinivan = true;
      }
      if(vehicle === VehiclesOfInterest.CROSSOVERS_SUVS) {
        editInquiryVehicle.vehiclesOfInterest.crossoversSuv = true;
      }
      if(vehicle === VehiclesOfInterest.ELECTRIFIED) {
        editInquiryVehicle.vehiclesOfInterest.electrified = true;
      }
      if(vehicle === VehiclesOfInterest.TRUCKS) {
        editInquiryVehicle.vehiclesOfInterest.trucks = true;
      }
    })
    return editInquiryVehicle;
  }
  return null;
}

export function getComment(data, field) {
  let returnComment = '';
  data.split(':::').forEach(comment=> {
    if(comment.includes(field)) {
      returnComment = comment.replace(`${field} - `, '').trim();
    }
  })
  return returnComment;
}

export function getTradeInVehicle(vehicles : IVehicle[]) : IVehicle[]{
  const tradeInVehicles = [];
  vehicles.forEach(tradeInVehicle=> {
    tradeInVehicles.push({
      year: tradeInVehicle &&  tradeInVehicle.year ? tradeInVehicle.year : '',
      make: tradeInVehicle && tradeInVehicle.make ? tradeInVehicle.make : '',
      model: tradeInVehicle && tradeInVehicle.model ? tradeInVehicle.model : '',
      vin: tradeInVehicle && tradeInVehicle.vin ? tradeInVehicle.vin : '',
      mileage: tradeInVehicle && tradeInVehicle.mileage ? +tradeInVehicle.mileage : 0,
      trim: tradeInVehicle && tradeInVehicle.trim ? tradeInVehicle.trim : '',
      isOwnVehicle : tradeInVehicle && tradeInVehicle.isOwnVehicle ? tradeInVehicle.isOwnVehicle : false
    })
  })
  return tradeInVehicles;
}

export function updateSalesAppointment(state: PartsAppointmentState, payload, dealerAddress, allTestDriveVehicles?:any): ISalesAppointment {
  const updateAppointment = createPartsAppointment(state, payload, dealerAddress, allTestDriveVehicles);
  updateAppointment.appointmentId = state.editDetails.appointmentId;
  updateAppointment.dealerCode = state.editDetails.dealerCode;
  return updateAppointment;
}

export function getSeriesAndTrim(value: any): SeriesDetailsForYear[] {
  const testDriveYears: number[] = getYearList();
  const seriesYearArray: SeriesDetailsForYear[] = [];


  value.series_data.forEach(seriesYear => {
    if (testDriveYears.findIndex(x => x === +seriesYear.year) > -1) {
      const seriesDataArray: SeriesData[] = [];
      seriesYear.series_list.forEach(element => {
        const seriesData: SeriesData = {
          modelCode: element.code,
          model: {
            modelCode: element.code,
            modelTitle: element.title
          },
          mileage: element.mileage?.combined_mpg,
          price: element.price?.starting_msrp,
          trims: []
        };
        element.trims.forEach(item => {
          const trim: Trim = {
            trimCode: item.code,
            trimTitle: item.title
          };
          seriesData.trims.push(trim);
        });
        seriesDataArray.push(seriesData);
      });

      seriesYearArray.push({
        year: seriesYear.year,
        seriesDetails: seriesDataArray
      });
    }
  });


  return seriesYearArray;
}

export const getYearList = (): number[] => {
  const date = new Date();
  return [date.getFullYear(), date.getFullYear() + 1];
};

export const getSeriesList = (seriesData: IAsyncData<SeriesDetailsForYear[]>, year: number): Model[] => {
  if (seriesData.data.length === 0) {
    return [];
  }

  const seriesDetailList = seriesData.data.find(x => +x.year === year)?.seriesDetails;
  const modelList: Model[] = [];
  if (seriesDetailList) {
    seriesDetailList.forEach(item => {
      if (modelList.findIndex(x => x.modelCode === item.modelCode) === -1) {
        modelList.push(item.model);
      }
    });
  }
  return modelList;
};

export const getTrimList = (seriesData: IAsyncData<SeriesDetailsForYear[]>, year: number, model: string): Trim[] => {
  if (seriesData.data.length === 0) {
    return [];
  }

  const seriesDetailList = seriesData.data.find(x => +x.year === year)?.seriesDetails;
  let trimList: Trim[] = [];
  if (seriesDetailList) {
    seriesDetailList.forEach(item => {
      if (item.modelCode === model) {
        trimList = item.trims;
      }
    });
  }
  return trimList;
};

export const getMileage = (seriesData: IAsyncData<SeriesDetailsForYear[]>, year: number, model: string): string => {
  if (seriesData.data.length === 0) {
    return '0.0';
  }

  const seriesDetailList = seriesData.data.find(x => +x.year === year)?.seriesDetails;
  let mileage = '0.0';
  if (seriesDetailList) {
    seriesDetailList.forEach(item => {
      if (item.modelCode === model) {
        mileage = item.mileage;
      }
    });
  }
  return mileage;
};

export const getPrice = (seriesData: IAsyncData<SeriesDetailsForYear[]>, year: number, model: string): string => {
  if (seriesData.data.length === 0) {
    return '0';
  }

  const seriesDetailList = seriesData.data.find(x => +x.year === year)?.seriesDetails;
  let price = '0';
  if (seriesDetailList) {
    seriesDetailList.forEach(item => {
      if (item.modelCode === model) {
        price = item.price;
      }
    });
  }
  return price;
};

export function getExteriorColors(value: any): VehicleColor[] {
  const exteriorColors: VehicleColor[] = [];


  value.colors.exterior.forEach(element => {
    const imageUrl = element.applicable && element.applicable.length ? element.applicable[0].override?.images?.car_jelly_image : undefined;
    exteriorColors.push({
      id: element.code,
      colorCode: '#' + element.hex_value[0],
      carImage: imageUrl || GLOBAL_CONSTANT.placeholderCarImage
    });
  });

  return exteriorColors;
}

export function getVehicleDetails(yearList, modelList, trimList, exteriorColors, mileage, price): VehicleDetails {
  return {
    exteriorColors,
    yearList,
    modelList,
    trimList,
    mileage,
    price
  };
}

export function getVehicleDetailsForVinTestDrive(state, exteriorColors, vehicle, mileage, price): VehicleDetails {
  const seriesData = state.allSeriesDetails?.data;
  const modelCode = seriesData?.model?.toLowerCase().replace(' ', '');
  return {
    yearList: [seriesData?.year],
    modelList: [{ modelTitle: seriesData?.model, modelCode: modelCode }],
    trimList: [{ trimCode: seriesData?.trim, trimTitle: seriesData?.marketingTitle }],
    exteriorColors,
    mileage,
    price
  }
}
export function updateAdvisorOnLanguageChange(state: PartsAppointmentState, value: IAvail): string {
  let advisorId = value.advisorId;
  const advisors = state.availabilityOptions?.data?.advisors
    ?.filter(a => a?.languages && a?.languages.length ? a?.languages?.some(l => l.languageId === value.languageId) : []);
  if (advisors && !advisors.find(x => x.id === advisorId)) {
    advisorId = '-1';
  }
  return advisorId;
}

export function updateTimeSlotOnDateChange(state: PartsAppointmentState, value: IAvail): string {
  let timeSlotId = value.timeSlotId;

  if (state.appointment.availability.appointmentStartDate !== value.appointmentStartDate) {
    const timeSlots = state.availability.data.availableDates
      ?.find(a => a.date === value.appointmentStartDate)
      ?.timeSlots;

    if (timeSlots?.length) {
      const openTimeSlots = timeSlots.filter(x => x.isOpen);
      timeSlotId = openTimeSlots.length ? openTimeSlots[0].timeSlotId : timeSlotId;
    }

  }

  return timeSlotId;
}

function setPartsAppointment(payload, availability, customer, transportationTypeCode, vehicle, tradein, deliveryAddress, appointmentComments) {

  const apptEmail = customer.emailAddress;
  const appt: IAppointment = {
    appointmentType: payload.appointmentType,
    emailAddress: apptEmail,
    languageId: availability.languageId,
    advisorId: availability.advisorId,
    timeSlotId: availability.timeSlotId,
    transportationTypeCode,
    appointmentStartDate: availability.appointmentStartDate,
    vehicle,
    appointmentCreatedRoles: ["ASP_ROLES"],
    customer: {
      firstName: customer.firstName,
      lastName: customer.lastName,
      emailAddress: customer.emailAddress,
      phoneNumber: customer.phoneNumber,
      customerType: customer.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
      businessName: customer.businessName || ''
    },
    appointmentComments: appointmentComments,
    settings:payload.settings
  }
  
  if (checkCommentsCondition(tradein)) {
    const apptComments = []
    if(tradein?.dealerComments){
      apptComments.push(`Comments-From-Dealer - ${tradein.dealerComments}`)
    }
    if(tradein?.internalComments){
      apptComments.push(`Dealer-Internal-Comments - ${tradein.internalComments}`)
    }
    if(tradein?.additionalComments){
      apptComments.push(`Customer-Additional-Comments - ${tradein.additionalComments}`)
    }
    if(tradein?.tradeInComments){
      apptComments.push(`Trade-in - ${tradein.tradeInComments}`)
    }
    appt.appointmentComments = apptComments.join(' ::: ')
  }

  return appt;
}

function checkCommentsCondition(tradein) {
  return (tradein.dealerComments || tradein.internalComments || tradein.tradeInComments || tradein.additionalComments) ? true : false;
}


/* Footer Summary */
export function appointmentVehicleFormToSummaryProjector(vehicleForm: IPartsVehicle) {
  /* Vehicle summary */
  const chosenVehicle = (vehicleForm.year && vehicleForm.model) ? `${vehicleForm.year} ${vehicleForm.model}` : '';
  return [{
    key: 'testDrive.vehicle',
    value: chosenVehicle
  }];
}

export function checklistDuration(checklist) {
  let duration = 0;
  if (checklist && checklist.isChildChecklistEnabled && checklist.childChecklist && checklist.childChecklist.length > 0) {
    duration = checklist.childChecklist.map(s => s.online ? s.duration : 0).reduce((total, current) => { return total + current }, 0)
  }
  else {
    duration = checklist?.duration;
  }
  return duration;
}

export function getChecklistDuration(selectedChecklist) {
  let selectedChecklistHours = 0;
  if (selectedChecklist && selectedChecklist.length > 0) {
    selectedChecklist.map(s => s.details).forEach(t => {
      selectedChecklistHours += checklistDuration(t);
    });
  }
  return selectedChecklistHours;
}

export function appointmentChecklistRequestFormToSummaryProjector(selectedChecklist: IChecklistRequest[],time:any) {
  const selectedChecklistHours = getChecklistDuration(selectedChecklist);
  let contracting = 0;
  if(time?.deliveryAppointmentDuration > 0){
    contracting = time?.deliveryAppointmentDuration
  } 
  const checklistHoursSummary = {
    key: 'delivery.estimatedDuration',
    value: convertMinsToHourMins(selectedChecklistHours+contracting, true),
    disclaimer: 'otherTexts.theActualDurationMayVaryAtTheDealership'
  };

  return [checklistHoursSummary];
}

export function getChecklistDurationForAvailability(checklistRequest: IChecklistRequest[]) {
  const duration = getChecklistDuration(checklistRequest);
  return { min: duration };
}

export const vehicleToMakeModelYearTextProjector = (vehicleForm: IPartsVehicle) => {
  return (vehicleForm.year && vehicleForm?.model) ? `${vehicleForm.year || ''} ${vehicleForm.model || ''}` : vehicleForm?.vin ? `VIN ${vehicleForm.vin}` : '';
};

export const buildSelectedChecklistInfo = (checklistRequest: IChecklistRequest[]): IChecklist[] => {
  const checklist =  checklistRequest.map(t => {
    return { ...t.details } as IChecklist;
  });
  const mandatory = checklist.filter(x=> x.isMandatory);
  const nonMandatory = checklist.filter(x=> !x.isMandatory);
  return [...mandatory, ...nonMandatory];
};

export const appointmentFormToDetailMap =
  (data: { appointmentForm: IPartsAppointmentForm, availabilityOptions: IAvailabilityOptions },
    dealerDetails: IDealerInfo) => {
    const appointmentDetails = data.appointmentForm;
    const isRemoteLocation = appointmentDetails.transportationTypeCode === TransportationType.REMOTE;

    const date = `${DateTime.fromISO(appointmentDetails.availability.appointmentStartDate).toFormat('MMMM dd')}`;
    const time = appointmentDetails.availability.timeSlotId;

    const dateTime = `${date} at ${time}`;

    const vehicle = appointmentDetails.vehicle;
    let advisorName;
    const advisorId=appointmentDetails?.availability?.advisorId;
    if(Number(advisorId)===-1)
    {
      advisorName='Any consultant';
    }
    else{
      advisorName = data.availabilityOptions?.advisors
      ?.find(advisor => advisor.id === appointmentDetails.availability.advisorId)
      ?.displayName;
    }
    const checklistData = buildSelectedChecklistInfo(appointmentDetails.checklistRequest);
    let checklist = '';

    if (checklistData && checklistData.length > 0) {
      for(let i = 0; i < checklistData.length; i++) {
        if(i < 5) {
          checklist += `${checklistData[i].displayName}\n`;
        }
        else if(i > 4 && checklistData.length > 5) {
          const remaining = checklistData.length - 5;
          checklist += `... + Additional ${remaining} checklist item${remaining > 1 ? 's' : ''}`;
          break;
        }
      }
    }

    let customerAddress = '';
    if (isRemoteLocation) {
      const custAdd = appointmentDetails.address;
      customerAddress = `otherTexts.weWillBringTheCarTo:\n${custAdd.addressLine1}, ${custAdd.addressLine2 ? custAdd.addressLine2 + ', ' : ''} ${custAdd.city}, ${custAdd.state} - ${custAdd.zip}`;
    }

    const makeModelYear = `${vehicle.year || ''} ${titleCase(vehicle.make) || ''} ${vehicle.model}`;

    const commentsFromDealer = appointmentDetails.tradeIn.dealerComments;
    const dealerInternalComment =  appointmentDetails.tradeIn.internalComments;
    const additionalComments =  appointmentDetails.tradeIn.additionalComments;

    const dealershipAddress = `${dealerDetails.addressShort}`;

    const detailMap = {
      'service.time': dateTime,
      'testDrive.vehicle': makeModelYear,
      'serviceSchedule.consultant': advisorName,
      'delivery.checkList': checklist,
      'delivery.commentsFromDealer': commentsFromDealer,
      'delivery.internalDealerComments': dealerInternalComment,
      'delivery.customerComments': additionalComments,
      'service.location': `${(isRemoteLocation ? customerAddress : dealershipAddress)}`
    };
    if(!commentsFromDealer) {
      delete detailMap['delivery.commentsFromDealer']
    }
    if(!dealerInternalComment) {
      delete detailMap['delivery.internalDealerComments']
    }
    if(!additionalComments) {
      delete detailMap['delivery.customerComments']
    }
    return detailMap as { [key: string]: string };
  }

export const inquiryVehicleAppointmentDetails = (appointment: IPartsAppointmentForm) => {
  const appointmentData = {...appointment};
  delete appointmentData.vehicle;
  delete appointmentData.checklistRequest;
  return appointmentData;
}

export function testdriveAppointmentDetails(appointment: IPartsAppointmentForm): any {
  const appointmentData = {...appointment};
  delete appointmentData.appointmentStatus;
  delete appointmentData.checklistRequest;
  delete appointmentData.inquiryVehicle;
  return appointmentData;
}

export function deliveryAppointmentDetails(appointment: IPartsAppointmentForm): any {
  const appointmentData = {...appointment};
  delete appointmentData.checklistRequest;
  delete appointmentData.appointmentStatus;
  delete appointmentData.inquiryVehicle;
  return appointmentData;
}


